enum GenericErrorCodes {
  PBERRForbiddenInvalidToken = "PBERRForbiddenInvalidToken",
  PBERRForbiddenTokenExpired = "PBERRForbiddenTokenExpired",
  PBERRUnknownError = "PBERRUnknownError",
  PBERRConflict = "PBERRConflict",
  PBERRForbidden = "PBERRForbidden",
  PBERRMaintenance = "PBERRMaintenance",
  PBERRMFARequired = "PBERRMFARequired",
  PBAUTHMFAUserNotFound = "PBAUTHMFAUserNotFound",
  PBERRTokenMissing = "PBERRTokenMissing",
  PBERRForbiddenNoPermission = "PBERRForbiddenNoPermission",
  PBERRForbiddenRestrictionCheckFailed = "PBERRForbiddenRestrictionCheckFailed",
  PBERRInternalServerError = "PBERRInternalServerError"
}

export default GenericErrorCodes
